import React from "react";
import { Route, BrowserRouter, Switch } from "react-router-dom";
import Home from "./containers/home";
import ChallengeFriend from "./containers/home/challengeFriend";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/home" component={Home} />
        <Route path="/utmana" component={ChallengeFriend} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
